"use client";

import { useUser } from "@highway/design-system";
import { dataFetcher, useSnackbar } from "@highway/hwy-design-system";
import { useSearchParams } from "next/navigation";
import React, { useEffect } from "react";

export default function Layout({ children }: { children: React.ReactNode }) {
    const searchParams = useSearchParams();
    const shareData = searchParams.get("share-data");
    const { getData, hasData } = useUser();
    const { addSnack } = useSnackbar();

    useEffect(() => {
        if (!hasData) {
            populateLOSession();
        }
    }, [hasData]);

    const populateLOSession = async () => {
        try {
            await dataFetcher(`/v1/share/live-share-auth?share-data=${shareData}`);
            getData();
        } catch (err) {
            console.log(err);
            addSnack({ message: "Failed to load social share", type: "error" });
        }
    };

    if (!hasData) return <></>;
    return children;
}
